'use client';
import { Section as SharedSection } from '@launchstore/shared-puck';
import type { SectionProps } from '@launchstore/shared-puck';
export const Section: any = SharedSection;
export type { SectionProps };
export default Section;
